import createRoute      from '@widesk-ui/tools/createRoute';
import PartnershipModel from '@models/website/PartnershipModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/partnerships',
	'website',
	'PartnershipSplitView',
	PartnershipModel.localize('plural'),
);
export default route;
